import styled, { css } from 'styled-components';

export const GlobalErrorContainer = styled.div`
  /* Błąd na środku widoku (w poziomie i w pionie). */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  width: 100%;
  min-height: calc(100dvh - 160px);
`;

export const DangerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 560px;
  width: 100%;
`;

export const IconWrapper = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.p`
  margin: 0 0 24px;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ErrorCodeBadge = styled.h1`
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.01em;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px 0;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  text-align: center;
  max-width: 800px;
`;

export const ErrorDetailsContainer = styled.div`
  width: 100%;
  margin-bottom: 28px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ErrorDetails = styled.details`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#ffffff')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  border-radius: 8px;
  padding: 12px 16px;
`;

export const ErrorSummary = styled.summary`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-right: 1.5px solid currentColor;
    border-bottom: 1.5px solid currentColor;
    transform: rotate(-45deg);
    transition: transform 0.2s ease;
  }

  ${ErrorDetails}[open] &::before {
    transform: rotate(45deg);
  }
`;

export const ErrorContent = styled.pre`
  margin: 12px 0 0 0;
  padding: 12px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#f9fafb')};
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  max-height: 300px;
  overflow: auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

// Akcje: zaokrąglone przyciski 44 px jak w formularzach. Główna akcja czarna,
// pozostałe jasne z ramką.
const pill = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 20px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  ${pill};
  padding: 0 24px;
  border: none;
  color: #ffffff;
  background: #111827;

  &:hover:not(:disabled) { background: #000000; }
`;

const secondaryPill = css`
  ${pill};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => (theme.mode === 'dark' ? 'transparent' : '#ffffff')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.06)' : '#f9fafb')};
    border-color: #9ca3af;
  }
`;

export const SecondaryButton = styled.button`
  ${secondaryPill};
`;

export const ReportButton = styled.button`
  ${secondaryPill};
`;

export const ReportStatus = styled.p<{ $variant: 'success' | 'error' }>`
  font-size: 13px;
  margin: 12px 0 0 0;
  width: 100%;
  text-align: center;
  color: ${({ $variant }) => ($variant === 'success' ? '#16a34a' : '#ef4444')};
`;
